export default __webpack_public_path__ + "static/media/kplus-info.63f9655b.svg";